// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Pa3CR4 {
  position: relative;
  display: inline-block;
  width: 40px;
  height: 24px;
}

.Pa3CR4 input {
  opacity: 0;
  width: 0;
  height: 0;
}

.EcYY9l {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: var(--toggle-track-off, #f2f2f2);
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.EcYY9l:before {
  position: absolute;
  content: '';
  height: 16px;
  width: 16px;
  left: 4px;
  bottom: 4px;
  background-color: var(--toggle-knob-off, #999999);
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked + .EcYY9l {
  background-color: var(--surface-primary-medium, #d64000);
}

input:checked + .EcYY9l:before {
  background-color: var(--toggle-knob-on, #f2f2f2);
  -webkit-transform: translateX(14px);
  -ms-transform: translateX(14px);
  transform: translateX(14px);
}

.EcYY9l:after {
  position: absolute;
  content: '✓';
  height: 16px;
  width: 16px;
  left: 4px;
  bottom: 4px;
  line-height: 16px;
  text-align: center;
  font-size: 11px;
  font-weight: 900;
  color: var(--toggle-check-off, transparent);
  -webkit-transition: 0.4s;
  transition: 0.4s;
  z-index: 1;
}

input:checked + .EcYY9l:after {
  color: var(--surface-primary-medium, #d64000);
  -webkit-transform: translateX(14px);
  -ms-transform: translateX(14px);
  transform: translateX(14px);
}

.EcYY9l.FeS8u9 {
  border-radius: 34px;
}

.EcYY9l.FeS8u9:before {
  border-radius: 50%;
}

.E55bEV {
  opacity: 0.5;
  cursor: not-allowed;
}
`, "",{"version":3,"sources":["webpack://./../../packages/shared-ui/src/components/Toggle/Toggle.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,kDAAkD;EAClD,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,SAAS;EACT,WAAW;EACX,iDAAiD;EACjD,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,wDAAwD;AAC1D;;AAEA;EACE,gDAAgD;EAChD,mCAAmC;EACnC,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,SAAS;EACT,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,2CAA2C;EAC3C,wBAAwB;EACxB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,6CAA6C;EAC7C,mCAAmC;EACnC,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB","sourcesContent":[".switch {\n  position: relative;\n  display: inline-block;\n  width: 40px;\n  height: 24px;\n}\n\n.switch input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.slider {\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: var(--toggle-track-off, #f2f2f2);\n  -webkit-transition: 0.4s;\n  transition: 0.4s;\n}\n\n.slider:before {\n  position: absolute;\n  content: '';\n  height: 16px;\n  width: 16px;\n  left: 4px;\n  bottom: 4px;\n  background-color: var(--toggle-knob-off, #999999);\n  -webkit-transition: 0.4s;\n  transition: 0.4s;\n}\n\ninput:checked + .slider {\n  background-color: var(--surface-primary-medium, #d64000);\n}\n\ninput:checked + .slider:before {\n  background-color: var(--toggle-knob-on, #f2f2f2);\n  -webkit-transform: translateX(14px);\n  -ms-transform: translateX(14px);\n  transform: translateX(14px);\n}\n\n.slider:after {\n  position: absolute;\n  content: '✓';\n  height: 16px;\n  width: 16px;\n  left: 4px;\n  bottom: 4px;\n  line-height: 16px;\n  text-align: center;\n  font-size: 11px;\n  font-weight: 900;\n  color: var(--toggle-check-off, transparent);\n  -webkit-transition: 0.4s;\n  transition: 0.4s;\n  z-index: 1;\n}\n\ninput:checked + .slider:after {\n  color: var(--surface-primary-medium, #d64000);\n  -webkit-transform: translateX(14px);\n  -ms-transform: translateX(14px);\n  transform: translateX(14px);\n}\n\n.slider.round {\n  border-radius: 34px;\n}\n\n.slider.round:before {\n  border-radius: 50%;\n}\n\n.disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"switch": `Pa3CR4`,
	"slider": `EcYY9l`,
	"round": `FeS8u9`,
	"disabled": `E55bEV`
};
module.exports = ___CSS_LOADER_EXPORT___;
